// =============================================
// qaOverrideService — ręczne zatwierdzenie publish mimo qa_status=needs_review/failed
// =============================================
//
// Bypass gate w publishQueueService.ts:311 (`if (qaStatus !== "approved") continue`)
// — gdy user ma artykuł z wysokim quality_score ale audit zwrócił needs_review
// (np. critical issue które user uznaje za false-positive lub akceptowalne),
// może ręcznie ustawić qa_status='approved' + flagę qa_override=true (audit trail).
//
// Wywoływane z UI button "Zatwierdź pomimo QA" w QueueDashboard.tsx
// (kolumna Status w tabeli readyArticles).

import { supabase } from "@/integrations/supabase/client";

export interface QaOverrideResult {
  success: boolean;
  error?: string;
}

/**
 * Force-approve QA dla pojedynczego node'a — bypass gate publish.
 * Ustawia qa_status='approved' + audit trail (qa_override / qa_override_by / qa_override_at / qa_override_reason).
 *
 * @param nodeId UUID node z tabeli thematic_nodes
 * @param reason Opcjonalny powód podany przez user-a (np. "false-positive schema check")
 */
export async function approveQaOverride(
  nodeId: string,
  reason?: string,
): Promise<QaOverrideResult> {
  if (!nodeId) return { success: false, error: "Brak nodeId" };

  const {
    data: { user },
    error: authErr,
  } = await supabase.auth.getUser();

  if (authErr || !user) {
    return { success: false, error: "Brak sesji użytkownika" };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { error } = await (supabase as any)
    .from("thematic_node_content")
    .update({
      qa_status: "approved",
      qa_override: true,
      qa_override_by: user.id,
      qa_override_at: new Date().toISOString(),
      qa_override_reason: reason?.trim() || null,
    })
    .eq("node_id", nodeId);

  if (error) {
    return { success: false, error: error.message };
  }

  return { success: true };
}
